const videoElement = document.createElement('video');
const audioElement = document.createElement('audio');

export const videoFormats = {
    vp9: { format: 'vp9', mimeType: 'video/webm' },
    h264: { format: 'h264', mimeType: 'video/mp4' },
};
export const audioFormats = {
    opus: { format: 'opus', mimeType: 'audio/webm;codecs=opus' },
    mp3: { format: 'mp3', mimeType: 'audio/mp3' },
};
const videoFormatsList = [videoFormats.vp9, videoFormats.h264];
const audioFormatsList = [audioFormats.opus, audioFormats.mp3];

export const canPlayTypeWrapper = (element, mimeType) => {
    try {
        const canPlay = element.canPlayType(mimeType);
        return canPlay === 'probably' || canPlay === 'maybe';
    } catch (e) {
        console.warn('canPlayType not available', e);
    }
    return false;
};

const mediaSupportService = {
    supportedVideoFormats: videoFormatsList.filter((formatModel) => {
        return canPlayTypeWrapper(videoElement, formatModel.mimeType);
    }),
    supportedAudioFormats: audioFormatsList.filter((formatModel) => {
        return canPlayTypeWrapper(audioElement, formatModel.mimeType);
    }),

    browserSupportsVideoFormat(possiblySupportedFormat) {
        return canPlayTypeWrapper(videoElement, this.getMimeTypeForVideoFormat(possiblySupportedFormat));
    },

    getMimeTypeForVideoFormat(format) {
        return videoFormatsList.find(formatModel => formatModel.format === format)?.mimeType;
    },

    getSupportedVideoFormats() {
        return mediaSupportService.supportedVideoFormats;
    },

    browserSupportsAudioFormat(possiblySupportedFormat) {
        return canPlayTypeWrapper(audioElement, this.getMimeTypeForAudioFormat(possiblySupportedFormat));
    },

    getMimeTypeForAudioFormat(format) {
        return audioFormatsList.find(formatModel => formatModel.format === format)?.mimeType;
    },

    getSupportedAudioFormats() {
        return mediaSupportService.supportedAudioFormats;
    },
};

export default mediaSupportService;
